<template lang="pug">
  DataTablePage(
    ref="collectorTable"
    mainColumn="name"
    longColumn="type"
    resource="/meterPayload/collector"
    title="采集设备管理"
    label="采集设备"
    labelName="name"
    :toolbar="toolbar"
    :operation="operation"
    :operationWidth=115
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :createList="createList"
    :updateList="updateList"
    :orderByInit="orderByInit"
    :columns="columns"
    @checkGroupValue="checkGroupValue")
    .toolBar(slot="toolbar")
      el-button.header-bottom
        a.download(:href="downLink" download="采集器模板") 下载导入模板
      el-upload(
        class="btn-upload"
        accept=".xls, .xlsx"
        name="uploadFile"
        :action="action"
        :show-file-list="false"
        :on-success="renderData"
        :headers="uploadHeader"
        :before-upload="beforeUpload")
        el-tooltip(content="只能上传excel文件" :enterable="false" placement="top")
          el-button(icon="plus" type="primary") 批量导入
</template>

<script>
import columns from './columns.js'
import DataTablePage from '@/containers/DataTablePage'
// import SmartDialog from '@/components/SmartDialog'
import { toolbarCreate } from '@/containers/DataTablePage/toolbar'
import { operationUpdate, operationDelete } from '@/containers/DataTablePage/operation'
import { checkActions, expire } from '@/utils/auth'
import { httpHeader, fetchDelete, fetch } from '@/utils/api'
import { URL, API } from '@/utils/common'
// import { fetchUpdate, fetchList } from '@/utils/api'

export default {
  name: 'Collector',
  components: {
    DataTablePage
  },
  data () {
    const hasUpdate = checkActions('/system/account/update')
    const hasDelete = checkActions('/system/account/delete')
    return {
      downLink: `${URL}/template/collector_template.xls`,
      toolbar: [{
        ...toolbarCreate,
        isShow () {
          return checkActions('/system/account/create')
        }
      }, {
        label: '批量删除',
        icon: 'delete',
        funcProps: {
          el: this
        },
        func ({funcProps}) {
          const { el } = funcProps
          const checkAllValue = el.checkAllValue
          checkAllValue.length ? el.showSwalWarn({
            text: '是否强制删除(包括下挂计量器)',
            cancelText: '取消'
          }, confirm => {
            el.deleteAllCheck(true)
          }, reject => {
            // el.deleteAllCheck(false)
          })
          : this.$swal('error', '请选择批量删除的采集设备', 'error')
        }
      }],
      operation: [{
        ...operationUpdate,
        isShow () {
          return hasUpdate
        }
      }, {
        ...operationDelete,
        isShow () {
          return hasDelete
        },
        funcProps: {
          el: this
        },
        func ({funcProps}) {
          const { el, data } = funcProps
          el.showSwalWarn({
            text: '是否删除当前采集器?',
            cancelText: '取消'
          }, () => {
            el.deleteList({
              resource: '/meterPayload/collector',
              id: data.id
            })
          })
        }
      }],
      isForce: false, // 是否强制删除
      uploadHeader: httpHeader({
        headers: { 'Gddx-Access-AppId': 'web' }
      }, this.$moment().format('x')),
      action: `${URL}${API}meterPayload/collector/batch`,
      checkAllValue: [],
      isUpload: false,
      isUpdateDialog: false,
      tableInitList: ['checkBox', 'name', 'code', 'payloadTypeId', 'createTime'],
      tableFullList: ['checkBox', 'id', 'name', 'code', 'payloadTypeId', 'createTime', 'creatorId'],
      filterInitList: ['name', 'code', 'payloadTypeId'],
      filterFullList: ['name', 'code', 'payloadTypeId'],
      createList: ['name', 'code', 'payloadTypeId'],
      updateList: ['name'],
      tableData: [],
      orderByInit: [{name: 'createTime', sort: 'desc'}],
      columns: {
        ...columns,
        payloadTypeId: {
          label: '设备类型',
          type: 'select',
          relation: 'collectorTypeId',
          width: 200,
          minLength: 300,
          filter: {
            type: 'select',
            width: 180
          },
          form: {
            type: 'select',
            size: 10,
            rules: [{
              type: 'required',
              message: '请选择设备类型'
            }]
          }
        }
      }
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  methods: {
    // 上传
    beforeUpload () {
      this.uploadHeader = httpHeader({
        headers: { 'Gddx-Access-AppId': 'web' }
      }, this.$moment().format('x'))
      return true
    },
    renderData (response) {
      const status = response.code === 0 ? 'success' : 'error'
      const message = response.code === 0 ? '导入成功' : '导入失败'
      this.$swal(message, response.message, status)
      this.$refs.collectorTable.getData()
    },
    checkGroupValue (value) {
      // 获得全选值
      this.checkAllValue = value
      // console.info('checkGroupValue-page:', value)
    },
    showSwalWarn (params = {text: '是否强制删除(包括下挂计量器)', cancelText: '取消'}, resolve, reject) {
      const { cancelText, text } = params
      this.$swal({
        title: '确定删除吗?',
        text: text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确认删除',
        cancelButtonText: cancelText
      }).then(confirm => {
        if (confirm) {
          resolve ? resolve() : null
        }
      }, close => {
        if (close === 'cancel') {
          reject ? reject() : null
        }
      })
    },
    deleteAllCheck (isForce) {
      fetch({
        method: 'delete',
        url: `/meterPayload/collector/batch?isForce=${isForce}`,
        data: {
          collectorIdArray: this.checkAllValue
        }
      }).then(res => {
        if (res) {
          this.$swal('删除成功', '', 'success')
          this.$refs.collectorTable.getData()
        }
      })
    },
    deleteList (params = {resource: '', id: 0}) {
      const { resource, id } = params
      fetchDelete({
        resource: resource,
        id: id
      }).then(res => {
        if (res) {
          this.$swal('删除成功', '', 'success')
          this.$refs.collectorTable.getData()
        } else {
          this.showSwalWarn({text: '该设备有下挂计量器', cancelText: '取消'}, confirm => {
            this.deleteList({
              resource: '/meterPayload/collector/force',
              id: id
            })
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="sass">
.toolBar
  display: inline-block
  margin-top: 5px
  .header-bottom
    margin-right: 10px
    .download
      color: #5e5e5e
  .btn-upload
    display: inline-block
</style>



// WEBPACK FOOTER //
// Collector.vue?1ffb5b22